import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ModalsProvider } from '@speeki/global-ui-components';

import { ProfileData } from '@components/_global/Header/Profile/ProfileData/ProfileData';
import { ProfileItem } from '@components/_global/Header/Profile/ProfileItem/ProfileItem';
import { ProfileItemsWrapper } from '@components/_global/Header/Profile/ProfileMobile/ProfileMobile.styled';

import { AuthService } from '@services/AuthService/AuthService';
import { getPath } from '@services/RouteService/paths';

import { useReactiveVar } from '@apollo/client';
import {
    subsidiarySiteUuidFromUrlVar,
    tenantModulesVar,
} from '@boot/reactiveVariables';

const ProfileMobile = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const tenantModules = useReactiveVar(tenantModulesVar);
    const subsidiarySiteUuidFromUrl = useReactiveVar(
        subsidiarySiteUuidFromUrlVar,
    );

    return (
        <>
            <ProfileData isMobile={true} />
            <ProfileItemsWrapper>
                {tenantModules.cases && (
                    <ProfileItem
                        actionName={t('MESSAGING_TEXT')}
                        icon={'Svg2DMessaging24'}
                        isMobile
                        onClick={() =>
                            navigate(getPath({ path: '/incidents' }))
                        }
                        testId="fqv8ZhJ"
                    />
                )}
                {!subsidiarySiteUuidFromUrl && tenantModules.surveys && (
                    <ProfileItem
                        actionName={t('SURVEY_TEXT')}
                        icon={'Svg2DSurvey24'}
                        isMobile
                        onClick={() =>
                            navigate(getPath({ path: '/survey/list' }))
                        }
                        testId="g7BoeRf"
                    />
                )}
                {!subsidiarySiteUuidFromUrl && tenantModules.disclosures && (
                    <ProfileItem
                        actionName={t('DISCLOSURE_TEXT')}
                        icon={'Svg2DDAndD24'}
                        isMobile
                        onClick={() =>
                            navigate(getPath({ path: '/disclosure/list' }))
                        }
                        testId="EHXWF6Z"
                    />
                )}
                <ProfileItem
                    actionName={t('SETTINGS')}
                    icon={'SvgSettings24'}
                    isMobile
                    onClick={() => navigate(getPath({ path: '/settings' }))}
                    testId="zz5xhj-"
                />
                <ProfileItem
                    actionName={t('CHANGE_SUBSIDIARY_SITE')}
                    icon={'SvgBriefcase24'}
                    isMobile
                    isTopDivider
                    onClick={() => ModalsProvider.open('EntityChangeModal')}
                    testId="QbpZyjy"
                />

                <ProfileItem
                    actionName={t('CHANGE_COMPANY_TEXT')}
                    icon={'SvgCompany24'}
                    isMobile
                    onClick={() => ModalsProvider.open('CompanyChangeModal')}
                    testId="9fwkRrY"
                />
                <ProfileItem
                    actionName={t('LOGOUT')}
                    icon={'SvgLogout24'}
                    isMobile
                    onClick={() => AuthService.logout(true)}
                    testId="H7jVOXx"
                />
            </ProfileItemsWrapper>
        </>
    );
};

export default ProfileMobile;
